<div id="tasks" class="sectionContainer paddedContent">
  <p>All tasks must be complete before you can mark this step as complete:</p>

  @for (step of steps; track step) {
    <div>
      <input type="checkbox" (change)="handleCheck_click(step.id)" />
      {{ step.text }}
    </div>
  }
</div>
